import {getObject, postObjectWithApiError, getJson, IResultAndError} from '../../lib/ChoiceApi'; 
import {IFeePractice,INegFeeResponse,INegFeeImport} from '../../lib/Models/FeeImportModel'; 
 
export enum ErrorReturnMessage {
    feeSetup = "Unable to obtain fee setup details",
    feeLoad = "Unable to obtain fee load details" 
};

export async function getFeeSetup(): Promise<IResultAndError<IFeePractice>>
{  
    let returnErrorMessage = "";
    const url = `api/Procedures/FeeImport/Setup/`;
    const responseObject = await getObject<IFeePractice>(url,(httResp, errorMessage) =>  { 
        returnErrorMessage = errorMessage ?? ErrorReturnMessage.feeSetup;
    });
    if (responseObject)
        return {success: responseObject};
    else 
        return {error: {error: returnErrorMessage}}; 
};   
export async function setFeeImport(payload: INegFeeImport): Promise<IResultAndError<INegFeeResponse>>
{
    return postObjectWithApiError("api/Procedures/FeeImport/Load", payload);
};